<template>
	<div class="bg">
		<img src="../../static/img/new/1.jpg" mode="widthFix" style="width: 99vw;">
		<div style="line-height: 50px;width: 400px;margin-left: 300px;">
			<div>联系方式：15958548188</div>
			<div>邮箱地址：45973501@qq.com</div>
			<div>公司地址：浙江省绍兴市越城区朝皇路718-9-401</div>
			<div>公司备案：浙ICP备2021037109号</div>
			
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		name: "screen",
		data() {
			return {
				

			};
		},
		mounted() {
			// this.drawExcel_sum()
			

		},
		methods: {
			
		},


	};
</script>

<style>
	

	
</style>


// WEBPACK FOOTER //
// src/pages/screen.vue